import {Button, createTheme, Input, Modal, rem} from "@mantine/core";
import {COR} from "./constantes/constantes-mantine";
import '../css/mantine.css'

export const TEMA = createTheme({
    primaryColor: 'indigo-full',
    colors: {
        'indigo-full': ['#EDF2FF', '#DBE4FF', '#BAC8FF', '#91A7FF', '#748FFC', '#5C7CFA', '#4C6EF5', '#4263EB', '#3B5BDB', '#364FC7'],
    },
    components: {
        Button: Button.extend({
            defaultProps: {
                color: COR.PRIMARIO,
                size: "sm"
            },
        }),
        Input: Input.extend({
            classNames: {
                input: "input",
            }
        }),
        Modal: Modal.extend({
            styles: {
              title: {
                  fontSize: rem(20),
                  fontWeight: "bold",
              }
            },
        })
    },
    breakpoints: {
        xs: '30em',
        sm: '48em',
        md: '64em',
        lg: '74em',
        xl: '90em',
    },
});